import React from "react";
import "./Contact.css";
import { VscGithub } from "react-icons/vsc";
import { CgMail } from "react-icons/cg";
import { BsInstagram, BsFillTelephoneFill } from "react-icons/bs";
import { ThemeContext } from "../../Context/theme";

import { FaLinkedin } from "react-icons/fa";
export const Contact = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <div className="section">
        <h2 className="section__title" data-aos="fade-left">
          Connect with <span className="different">me</span>
        </h2>
        <div className={"contactcontainer " + themename} >
          <a
            href="https://www.linkedin.com/in/shilajit-paul-a7aba7153/"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedin className="linkedin" />
          </a>
          <a
            href="https://github.com/iShilajit"
            target="_blank"
            rel="noreferrer"
          >
            <VscGithub className="github" />
          </a>
          
        
          <a
            href="https://www.instagram.com/i_sanatani_shilajit/"
            target="_blank"
            rel="noreferrer"
          >
            <BsInstagram className="twitter" />
          </a>
          <span>
          <a href="tel:+919804852663" target="_blank" rel="noreferrer">
            <BsFillTelephoneFill className="phone" />
            
          </a>
          <p className="allhide" style={{marginLeft:"-20%"}}>+919804852663</p>
          </span>
         
          <span>
          <a
            href="mailto:shilajit2014paul@gmail.com"
            target="_blank"
            rel="noreferrer"
          >
            <CgMail className="email" />
          </a>
          <p className="allhide" style={{marginLeft:"-35%"}}>shilajit2014paul@gmail.com</p>
          </span>
        </div>
       
      </div>
    </>
  );
};
